var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 20,
    viewBox: "0 0 33 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8181 1.63634V9.81816C32.8181 10.6363 32.2726 11.1818 31.4545 11.1818C30.6363 11.1818 30.0908 10.6363 30.0908 9.81816V4.90907L19.4545 15.5454C18.909 16.0909 18.0908 16.0909 17.5454 15.5454L11.6817 9.6818L2.409 18.9545C2.13627 19.2272 1.86355 19.3636 1.45446 19.3636C1.04537 19.3636 0.772639 19.2272 0.499911 18.9545C-0.0455433 18.4091 -0.0455433 17.5909 0.499911 17.0454L10.7272 6.81816C11.2726 6.2727 12.0908 6.2727 12.6363 6.81816L18.4999 12.6818L28.1817 2.99998H23.2726C22.4545 2.99998 21.909 2.45452 21.909 1.63634C21.909 0.81816 22.4545 0.272705 23.2726 0.272705H31.4545C31.5908 0.272705 31.8635 0.272705 31.9999 0.409069C32.2726 0.545432 32.5454 0.81816 32.6817 1.09089C32.8181 1.22725 32.8181 1.49998 32.8181 1.63634Z",
    fill: "#3d8ecc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSold);
export default __webpack_public_path__ + "static/media/sold.e5def1e042504dff9b5eb249018f24b7.svg";
export { ForwardRef as ReactComponent };